// 每日小時成本
import * as types from '../actionType';

let initState = {
  resources: [],
  events: []
};

function DailyCostByHour(state = initState, action) {
  switch (action.type) {
      case types.DAILY_COST_BY_HOUR_SUCCESS:{
        return action.result;
      }
      default:
        return state;
  }
}


export default DailyCostByHour;